// extracted by mini-css-extract-plugin
export var background = "_6l-0";
export var container = "_6l-1";
export var contentItem = "_6l-7";
export var extendedWarranty = "_6l-5";
export var link = "_6l-d";
export var modal = "_6l-b";
export var modalCloseButton = "_6l-9";
export var modalContent = "_6l-3";
export var modalContentMain = "_6l-6";
export var modalImageLogo = "_6l-8";
export var modalLogo = "_6l-a";
export var modalSideImage = "_6l-4";
export var preview = "_6l-c";
export var redoModal = "_6l-2";